import { createIcon } from '../icon'
import AccountIcon from '../svg/AccountIcon'

export const AccountIconDefault = createIcon(AccountIcon)
